// @ts-nocheck
import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import LiveTranscript from '../LiveTranscript';

/**
 * LiveCallCard — molécule "appel en cours" affichée EN HAUT de la modale prospect.
 *
 * 2026-06-04 (Kevin demo final) :
 *  - Plus de bordures externes : le composant s'integre directement dans
 *    la modale, sans wrapper visuel marque.
 *  - Mini-bandeau dernier transcript : affiche speaker + texte si dispo,
 *    sinon un message contextualise (inbound = pas de STT, outbound = en
 *    attente). Plus de "En ecoute de la conversation" qui ment sur inbound.
 *  - Coach IA panel en-dessous (240px).
 *
 * Note : sur les appels INBOUND externes, le TwiML voice-handler ne pose
 * pas de `<Start><Stream>` -> pas de transcription temps reel disponible.
 * Cf. docs/STT-STREAMING-PLAN.md. Le mini-bandeau le signale clairement.
 */
export default function LiveCallCard({ callId, isInbound = false }) {
  const { t } = useTranslation('dialer');
  const [lastSegment, setLastSegment] = useState(null);
  const handleSegment = useCallback((seg) => {
    if (seg && seg.text) setLastSegment(seg);
  }, []);

  if (!callId) return null;

  const speakerLabel = lastSegment?.speaker === 'inbound' || lastSegment?.speaker === 'prospect'
    ? 'Prospect'
    : lastSegment?.speaker === 'outbound' || lastSegment?.speaker === 'agent'
      ? 'Agent'
      : '';

  return (
    <div>
      {/* Mini-bandeau dernier transcript live (sans bordure) */}
      <div className="px-1 py-2 text-sm" style={{ minHeight: 32 }}>
        {lastSegment ? (
          <p className="leading-snug" style={{ color: '#374151' }}>
            {speakerLabel && (
              <span className="mr-2 text-xs font-semibold uppercase tracking-wide" style={{ color: 'var(--vf-text-3, #6b7280)' }}>
                {speakerLabel}
              </span>
            )}
            {lastSegment.text}
          </p>
        ) : (
          <p className="text-xs italic" style={{ color: 'var(--vf-text-3, #9ca3af)' }}>
            {t('dialer:liveCallCard.waitingFirstExchange')}
          </p>
        )}
      </div>

      {/* Coach IA panel */}
      <div className="flex flex-col mt-2" style={{ height: 240 }}>
        <LiveTranscript callId={callId} onSegment={handleSegment} />
      </div>
    </div>
  );
}
